import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import AdminCard from "../../components/AdminCard"
import Loader from '../../components/Loader'

const StoreAdmins = () => {
    const [storeAdmins, setStoreAdmins] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const {name} = useParams()

    useEffect(() => {
        const getAdmins = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${encodeURIComponent(name)}/admins`)
                setIsLoading(false)
                // console.log(response)
                if (response) {
                    setStoreAdmins(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getAdmins()
    }, [])
    return (
        <div className="shop-admins">
            <div className="admins-page-header">
                <h2 className="store-name">{name}</h2>
                <p className='page-title'>Admins</p>
            </div>
            <div className="admins-list">
                {
                    storeAdmins?.length>=0 && storeAdmins.map((admin)=>(
                        <AdminCard admin={admin} />
                    ))
                }
            </div>
            {
                isLoading && <Loader />
            }
        </div>
    )
}

export default StoreAdmins